<template>
  <v-card>
    <v-card-title class="headline pb-0 px-4" primary-title>
      {{ $t('message.wizard.new.dayparting') }}
    </v-card-title>

    <v-card-text class="py-0 px-0">
      <v-stepper v-model="step" color="info" class="elevation-0">

        <v-stepper-header class="elevation-0">
          <v-stepper-step color="info" :complete="step === 2" :step="1">
            {{ $t('message.wizard.moduleConfig') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step color="info" :step="2">
            {{ $t('message.wizard.eventConfig') }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="elevation-0" style="min-height: 275px">
          <v-stepper-content class="py-0" :step="1">
            <v-select :label="$t('message.wizard.selectRow')"
                      :items="availableRows"
                      name="row"
                      v-model="row"></v-select>

            <v-text-field :label="$t('message.form.fields.moduleName')"
                          name="alias"
                          :disabled="!row"
                          v-model="alias"></v-text-field>

            <v-text-field :label="$t('message.form.fields.moduleType')"
                          name="type"
                          :readonly="true"
                          :disabled="!row"
                          :value="moduleDescription"
                          :placeholder="$t('message.wizard.new.addModuleContinue')"
                          append-outer-icon="add"
                          @click:append-outer="createModule"></v-text-field>

          </v-stepper-content>

          <v-stepper-content class="py-0" :step="2">
            <nx-dayparting-event-editor ref="editor" v-model="event"></nx-dayparting-event-editor>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn dark flat color="error" @click="cancel">Cancelar</v-btn>

      <v-btn
          v-if="isFinalStep"
          color="secondary"
          flat
          @click="create">
        Crear
      </v-btn>
      <v-btn
          v-else
          color="secondary"
          flat
          @click="nextStep"
          :disabled="disabledNextStep">
        Continuar
      </v-btn>

    </v-card-actions>

    <nx-composition-module-wizard-modal
        :active="moduleWizard"
        :available-modules="availableModules"
        :title="$t('message.wizard.new.addModule')"
        @dismiss="moduleWizard = false"
        @input="handleCreateModule"
    ></nx-composition-module-wizard-modal>
  </v-card>
</template>

<script>
import NxDaypartingEventEditor from '@/modules/board/dayparting/components/EventEditor';
import NxCompositionModuleWizardModal from '@/modules/composition/components/module/CompositionModuleWizardModal';
import { SCHEDULE_TYPE_ONCE } from '@/modules/board/dayparting/config';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import uuid from 'uuid/v4';

export default {
  name: 'nx-dayparting-module-event-wizard',
  components: {
    NxCompositionModuleWizardModal,
    NxDaypartingEventEditor,
  },
  data() {
    return {
      step: 1,
      row: null,
      alias: null,
      moduleWizard: false,
      module: {},
      event: {
        scheduleType: SCHEDULE_TYPE_ONCE,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        days: [],
      },
    };
  },
  computed: {
    ...mapGetters('dayparting', ['rows', 'availableModules']),
    availableRows() {
      return this.rows.map((row, index) => ({
        text: `Fila ${index + 1}`,
        value: row.uuid,
      }));
    },
    isFinalStep() {
      return this.step === 2;
    },
    disabledNextStep() {
      return !this.row || !this.alias || isEmpty(this.module);
    },
    moduleDescription() {
      if (!this.module.type) {
        return null;
      }
      return this.availableModules.find(module => module.type === this.module.type).name || null;
    },
    moduleConfig() {
      if (!this.module.type) {
        return null;
      }
      return this.availableModules.find(module => module.type === this.module.type) || null;
    },
  },
  methods: {
    nextStep() {
      this.step += 1;
    },
    close() {
      this.$emit('close');
    },
    reset() {
      this.step = 1;
      this.row = null;
      this.alias = null;
      this.module = {};
      this.event = {
        scheduleType: 1,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        days: [],
      };
    },
    cancel() {
      this.reset();
      this.close();
    },
    create() {
      const moduleEvent = {
        uuid: uuid(),
        module: {
          ...this.module,
          ...{ alias: this.alias },
        },
        event: this.$refs.editor.event,
      };

      if (this.moduleConfig.slots && this.moduleConfig.slots.length > 0) {
        moduleEvent.slots = this.moduleConfig.slots.map(slot => ({
          uuid: uuid(),
          type: slot.type,
        }));
        moduleEvent.module.slotIds = moduleEvent.slots.map(slot => slot.uuid);
      }

      this.$emit('create', {
        row: this.row,
        moduleEvent,
      });
      this.reset();
    },
    createModule() {
      this.moduleWizard = true;
    },
    handleCreateModule(type, fields) {
      this.module = {
        uuid: uuid(),
        alias: this.alias,
        type,
      };

      if (!isEmpty(fields)) {
        // Añadimos los fields al modulo
        this.module.fields = fields;
      }

      console.log('Module created', this.module);
      this.moduleWizard = false;
    },
  },
};
</script>
